import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import About from "./AboutArea";
import FunFact from "./FunFactArea";
import Service from "./ServiceArea";
import Work from "./WorkArea";
import Testimonial from "./TestimonialArea";
import Newsletter from "../../components/Newsletter";
import Team from "./TeamArea";
import OurStoryMain from "../our-story/OurStoryMain";
import ChairmanMessageMain from "../chairman-message/ChairmanMessageMain";
import CeoMessageMain from "../ceo-message/CeoMessageMain";
import VisionMissionMain from "../vision-mission/VisionMissionMain";
import TeamMain from "../team/TeamMain";
import OurDoctors from "../our-doctors/index";
import TestimonialMain from "../testimonial/TestimonialMain";
import FaqMain from "../faq/FaqMain";

const AboutMain = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }
  }, [hash]);

  return (
    <main>
      <Breadcrumb title="About us" />
      <About />
      <FunFact />
      <Service />
      <Work />
      <Testimonial />
      <Newsletter />
      <Team />
      <div id="our-story">
        <OurStoryMain asSection />
      </div>
      <div id="chairman-message">
        <ChairmanMessageMain asSection />
      </div>
      <div id="ceo-message">
        <CeoMessageMain asSection />
      </div>
      <div id="vision-mission">
        <VisionMissionMain asSection />
      </div>
      <div id="our-team">
        <TeamMain asSection />
      </div>
      <div id="our-doctors">
        <OurDoctors asSection />
      </div>
      <div id="testimonials">
        <TestimonialMain asSection />
      </div>
      <div id="faqs">
        <FaqMain asSection />
      </div>
    </main>
  );
};

export default AboutMain;
